//@flow

// Vendors
import React from 'react';
import {useDispatch} from 'react-redux';

// Components
import {Modal} from '../../../../../modals';
import Trans from '../../../../../Trans/Trans';

// Actions
import {closeModal} from '../../../../../../../reducers/modal/modalActions';

// Styles
import '../dps-learn-more-modal.scss';
import {TxButton, TxButtonMode} from "texkit-ui";

const DpsCompletedApplicationFormModal = () => {
  // Switch to adjusted SCSS if on iOS device
  const userAgent = window.navigator.userAgent.toLowerCase();
  const ios = /iphone|ipod|ipad/.test( userAgent );
  const dispatch = useDispatch();
  return (
    <Modal
      name="DpsCompletedApplicationFormModal"
      className={
        ios ? "learn-more modal ios" : "learn-more modal"
      }
    >
      <div>
        <h2 className="h2 modal-header">
          <Trans file="dps" id="dps_CompletedApplicationForm_Modal_Title"/>
        </h2>
        <p className="modal-description">
          <Trans file="dps" id="dps_CompletedApplicationForm_Modal_Desc1"/>
          <Trans file="dps" id="dps_CompletedApplicationForm_Modal_Desc2"/>
          <Trans file="dps" id="dps_CompletedApplicationForm_Modal_Desc3"/>
          <Trans file="dps" id="dps_CompletedApplicationForm_Modal_Desc4"/>
        </p>
      </div>

      <TxButton className="modal-close-button"
                mode={TxButtonMode.Primary}
                onClick={() => dispatch(closeModal("DpsCompletedApplicationFormModal"))}
      >
        <Trans file="Labels" id="gotIt" fallback="OK, got it"/>
      </TxButton>

    </Modal>
  );
};

export default DpsCompletedApplicationFormModal;
